import React from 'react';

const Product = () => {
  const productFeatures = [
    'Production Planning & Monitoring',
    'Inventory & Warehouse Management',
    'Financial Reporting & Accounting',
    'Procurement & Supplier Management',
    'Quality Control & Compliance',
    'BI & Analytics Dashboard'
  ];

  return (
    <section className="product" id="product">
      <div className="container">
        <div className="product-container">
          <div className="product-img">
            <img src="/product.png" alt="WorkflowNL Dashboard" />
          </div>
          <div className="product-info">
            <h2>Workflow</h2>
            <p>Our flagship product integrates all aspects of your manufacturing environment into one intuitive system.</p>
            <div className="product-features">
              {productFeatures.map((feature, index) => (
                <div className="product-feature" key={index}>
                  <span className="check-icon">✓</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
            <a href="#demo" className="btn">View a Demo</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;